// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__11GKs","body":"style_body__tvVmn","sampleImageContainer":"style_sampleImageContainer__3n9eB","sampleImage":"style_sampleImage__2Niao"};